
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree764"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree764"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8PEJB", function(module, exports) {

$parcel$export(module.exports, "AppConfig", () => $cfa613301632ce3c$export$d67e1898834e3885);
$parcel$export(module.exports, "rawAppConfig", () => $cfa613301632ce3c$export$dc600fc58bad63a4);
$parcel$export(module.exports, "LoadConfig", () => $cfa613301632ce3c$export$cb94587d85139210);
// @ts-ignore

var $e8Hjv = parcelRequire("e8Hjv");
const $cfa613301632ce3c$export$d67e1898834e3885 = {
    uiVersion: "4.15.0"
};
let $cfa613301632ce3c$export$dc600fc58bad63a4 = "";
async function $cfa613301632ce3c$export$cb94587d85139210() {
    let cfg = await (0, $e8Hjv.makeApiRequest)("GET", "/config");
    console.log("Got config", cfg);
    $cfa613301632ce3c$export$dc600fc58bad63a4 = cfg.config;
    Object.assign($cfa613301632ce3c$export$d67e1898834e3885, JSON.parse(cfg.config));
}

});
parcelRegister("e8Hjv", function(module, exports) {

$parcel$export(module.exports, "makeApiRequest", () => $defc9d1338eed012$export$f862cea947f5d50f);

var $8STwR = parcelRequire("8STwR");

var $hWSXx = parcelRequire("hWSXx");

var $bNXDl = parcelRequire("bNXDl");
let $defc9d1338eed012$var$authWindows = [];
let $defc9d1338eed012$var$reauthPromise;
let $defc9d1338eed012$var$authChannel = new BroadcastChannel("auth");
async function $defc9d1338eed012$export$f862cea947f5d50f(method, url, body) {
    let resp;
    try {
        resp = await fetch("/api" + url, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': $defc9d1338eed012$var$reauthPromise ? await $defc9d1338eed012$var$reauthPromise : localStorage.getItem("token") || ""
            },
            body: body && JSON.stringify(body)
        });
    } catch (e) {
        console.error(e);
    }
    if (!resp || resp.status == 503) {
        let retryAfter = 1000;
        if (resp && resp.headers.has("Retry-After")) {
            retryAfter = parseInt(resp.headers.get("Retry-After"));
            if (isNaN(retryAfter)) retryAfter = 1000;
        }
        console.error((resp ? "Got no response" : "Got 503") + " retrying in " + retryAfter + "ms");
        await (0, $8STwR.sleep)(retryAfter);
        return $defc9d1338eed012$export$f862cea947f5d50f(method, url, body);
    } else if (resp.status == 401 && window['APP_INIT'] == true) {
        $defc9d1338eed012$var$reauthPromise = new Promise(async (resolve, reject)=>{
            let win = window.open(await (0, $hWSXx.getLoginUrl)(), "auth", "width=600,height=600");
            if (!win) throw new Error("Failed to open Zoho login window");
            $defc9d1338eed012$var$authWindows.push(win);
            win?.focus();
            $defc9d1338eed012$var$authChannel.onmessage = (e)=>{
                if (e.data.token) {
                    console.log(e.data);
                    resolve(e.data.token);
                    for (var win of $defc9d1338eed012$var$authWindows)win.close();
                    $defc9d1338eed012$var$authWindows = [];
                } else reject(new Error(e.data.error ?? JSON.stringify(e.data)));
            };
        });
        return $defc9d1338eed012$export$f862cea947f5d50f(method, url, body);
    } else return (await (0, $bNXDl.checkError)(resp)).json();
}
window.makeApiRequest = $defc9d1338eed012$export$f862cea947f5d50f;

});
parcelRegister("8STwR", function(module, exports) {

$parcel$export(module.exports, "sleep", () => $46a906efaec40693$export$e772c8ff12451969);
function $46a906efaec40693$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(()=>resolve(true), ms));
}

});

parcelRegister("hWSXx", function(module, exports) {

$parcel$export(module.exports, "acceptInvite", () => $d5e3abaea1a8a816$export$f17229473791149b);
$parcel$export(module.exports, "tryAuthenticate", () => $d5e3abaea1a8a816$export$547b28f1d2f5f410);
$parcel$export(module.exports, "getLoginUrl", () => $d5e3abaea1a8a816$export$8abe2e83e8d74da2);
$parcel$export(module.exports, "userLogin", () => $d5e3abaea1a8a816$export$1eb8f48a6d6077d1);
$parcel$export(module.exports, "cachedUserData", () => $d5e3abaea1a8a816$export$b860f8e51057c9ce);
$parcel$export(module.exports, "userIsAuthed", () => $d5e3abaea1a8a816$export$a247694a2692735);
$parcel$export(module.exports, "logout", () => $d5e3abaea1a8a816$export$a0973bcfe11b05c9);

var $e8Hjv = parcelRequire("e8Hjv");

var $5PVUk = parcelRequire("5PVUk");
async function $d5e3abaea1a8a816$export$f17229473791149b() {
    let code = (0, $5PVUk.queryDecode)(location.search).code;
    history.replaceState({}, "Accepting invite", "/") // hide sensitive data from url
    ;
    sessionStorage.setItem('invite-token', code);
}
async function $d5e3abaea1a8a816$export$547b28f1d2f5f410() {
    let service = location.pathname.split("/")[3];
    let data = {
        ...(0, $5PVUk.queryDecode)(location.search),
        ...(0, $5PVUk.queryDecode)(location.hash?.replace('#', ""))
    };
    history.replaceState({}, "Logging in", "/") // hide sensitive data from url
    ;
    let invite = sessionStorage.getItem('invite-token');
    sessionStorage.removeItem('invite-token');
    console.log(invite ? "Registering" : "Logging in with", service, data);
    let response = invite ? await (0, $e8Hjv.makeApiRequest)('POST', `/auth/register/${service}`, {
        invite: invite,
        data: data
    }) : await (0, $e8Hjv.makeApiRequest)('POST', `/auth/login/${service}`, data);
    if (response.error) throw new Error(response.error);
    if (!response.token) throw new Error('No token returned');
    let tokenData = JSON.parse(atob(response.token.split(".")[0]));
    switch(tokenData.t){
        case 1:
            location.replace("/auth/invite?code=" + encodeURIComponent(response.token));
            return;
        case 0:
            break;
        default:
            throw new Error("Unknown token type: " + tokenData.t);
    }
    localStorage.setItem('token', response.token);
    new BroadcastChannel("auth").postMessage({
        type: "auth",
        token: response.token
    });
}
async function $d5e3abaea1a8a816$export$8abe2e83e8d74da2() {
    let methods = await (0, $e8Hjv.makeApiRequest)('GET', '/auth/login');
    let redirectLink = Object.values(methods).find((a)=>a.redirect);
    if (!redirectLink) throw new Error('No suitable login methods available');
    return redirectLink.redirect;
}
async function $d5e3abaea1a8a816$export$1eb8f48a6d6077d1() {
    location.assign(await $d5e3abaea1a8a816$export$8abe2e83e8d74da2());
    return new Promise(()=>{});
}
let $d5e3abaea1a8a816$export$b860f8e51057c9ce;
function $d5e3abaea1a8a816$export$a247694a2692735() {
    return (0, $e8Hjv.makeApiRequest)('GET', "/auth/").then((user)=>$d5e3abaea1a8a816$export$b860f8e51057c9ce = user).catch(()=>false);
}
function $d5e3abaea1a8a816$export$a0973bcfe11b05c9() {
    return (0, $e8Hjv.makeApiRequest)('POST', "/auth/logout").then((status)=>{
        if (!status.ok) throw new Error("Logout failed");
    });
}

});
parcelRegister("5PVUk", function(module, exports) {

$parcel$export(module.exports, "queryEncode", () => $ed05492a453bcaa5$export$1f8ce47f7a2fcb9);
$parcel$export(module.exports, "queryDecode", () => $ed05492a453bcaa5$export$8d8909991b596ef5);
$parcel$export(module.exports, "applyURLParams", () => $ed05492a453bcaa5$export$7fca118391ec88d4);
function $ed05492a453bcaa5$export$1f8ce47f7a2fcb9(object) {
    var query = new URLSearchParams(Object.fromEntries(Object.entries(object).filter(([k, v])=>v !== undefined && v !== null).map(([k, v])=>[
            k,
            v + ""
        ]))).toString();
    return query.length ? "?" + query : "";
}
function $ed05492a453bcaa5$export$8d8909991b596ef5(query) {
    if (query.includes("?")) query = query.split("?")[1];
    return Object.fromEntries([
        ...new URLSearchParams(query).entries()
    ]);
}
function $ed05492a453bcaa5$export$7fca118391ec88d4(url, params) {
    params = {
        ...url.includes("?") ? $ed05492a453bcaa5$export$8d8909991b596ef5(url) : {},
        ...params
    };
    return url.split("?")[0] + $ed05492a453bcaa5$export$1f8ce47f7a2fcb9(params);
}

});


parcelRegister("bNXDl", function(module, exports) {

$parcel$export(module.exports, "checkError", () => $2f0321c09e402c1b$export$2ceba9378ca07bfa);
class $2f0321c09e402c1b$var$ApiError extends Error {
    constructor(originalError, customMessage){
        super(customMessage || originalError.error);
        this.originalMessage = originalError.error;
        this.name = originalError.code;
        this.serverStack = originalError.full;
        this.data = originalError.data;
    }
}
class $2f0321c09e402c1b$var$MongoUniqueError extends $2f0321c09e402c1b$var$ApiError {
    constructor(originalError){
        let message = "Another resource matching the following unique fields already exists: \n";
        for (let [k, v] of Object.entries(originalError.data.keyValue || {}))message += ` - ${k}: ${JSON.stringify(v)}\n`;
        super(originalError, message.trim());
        this.invalidFields = Object.keys(originalError.data.keyValue);
    }
}
class $2f0321c09e402c1b$var$ValidationFailError extends $2f0321c09e402c1b$var$ApiError {
    constructor(originalError){
        const issues = Array.isArray(originalError.data) ? originalError.data : [];
        const parts = issues.map((r)=>{
            let msg = String(r.message || "Invalid input");
            if (r.validation == "regex") msg = "wasn't in the expected format";
            msg = msg.replace(/^validateProperties:\s*/i, "");
            const path = Array.isArray(r.path) ? r.path.filter((p)=>p !== undefined && p !== null && `${p}` !== "").join(".") : "";
            return {
                path: path,
                msg: msg
            };
        });
        // Full-sentence guidance (e.g. "Please set...") — show as the error text, not a schema dump.
        const guidanceOnly = parts.length > 0 && parts.every((p)=>/^please\b/i.test(p.msg));
        const message = guidanceOnly ? parts.map((p)=>p.msg).filter((msg, i, arr)=>arr.indexOf(msg) === i).join("\n") : ("The data provided did not pass validation: \n" + parts.map((p)=>p.path ? ` - ${p.path}: ${p.msg}` : ` - ${p.msg}`).join("\n")).trim();
        super(originalError, message);
        this.invalidFields = parts.map((p)=>p.path).filter(Boolean);
    }
}
function $2f0321c09e402c1b$var$getError(response) {
    let json;
    json = JSON.parse(response);
    if (!json || !json.error) return new Error(response);
    switch(json.code){
        case "MONGO_11000":
            return new $2f0321c09e402c1b$var$MongoUniqueError(json);
        case "SCHEMA_VALIDATION_FAILED":
            return new $2f0321c09e402c1b$var$ValidationFailError(json);
        default:
            return new $2f0321c09e402c1b$var$ApiError(json);
    }
}
async function $2f0321c09e402c1b$export$2ceba9378ca07bfa(res) {
    if (!res.ok) throw $2f0321c09e402c1b$var$getError(await res.text());
    else return res;
}

});



parcelRegister("lsO5g", function(module, exports) {

$parcel$export(module.exports, "ColourSchemes", () => $a5da0c8d6fec5f56$export$9afd924e1b138664);
$parcel$export(module.exports, "themeManager", () => $a5da0c8d6fec5f56$export$aba92a7f3273f617);

var $8PEJB = parcelRequire("8PEJB");

var $kms24 = parcelRequire("kms24");
const $a5da0c8d6fec5f56$export$f0368d77463bcee8 = [
    "slim",
    "default",
    "wide",
    "fill"
];
const $a5da0c8d6fec5f56$export$9afd924e1b138664 = [
    "light",
    "dark",
    "auto"
];
function $a5da0c8d6fec5f56$var$isValidColourScheme(scheme) {
    return $a5da0c8d6fec5f56$export$9afd924e1b138664.includes(scheme) ? scheme : false;
}
async function $a5da0c8d6fec5f56$var$applyDocumentTheme(accent, scheme, neutral, width) {
    let doc = document.documentElement;
    let className = `${accent} ${scheme} m-${neutral} pagewidth-${width}`;
    try {
        await document.startViewTransition(()=>{
            doc.className = className + ' noTransition';
        }).finished;
    } catch (e) {
        doc.className = className + ' noTransition';
        doc.offsetHeight; // force the browser to recalculate the styles
    } finally{
        doc.className = className;
    }
}
class $a5da0c8d6fec5f56$var$ThemeManager {
    on(fn) {
        this.listeners.push(fn);
    }
    constructor(){
        this.listeners = [
            $a5da0c8d6fec5f56$var$applyDocumentTheme
        ];
        this.apply();
    }
    apply() {
        let accent = this.accent;
        let scheme = this.scheme;
        let neutral = this.neutral;
        let width = this.width;
        this.listeners.forEach((fn)=>setTimeout(()=>fn(accent, scheme, neutral, width), 0));
    }
    get accent() {
        if ((0, $8PEJB.AppConfig).ENV == "crm-uat") return "orange";
        return (0, $kms24.isValidColour)(localStorage.getItem("accent")) || "cyan";
    }
    set accent(color) {
        localStorage.setItem("accent", color);
        this.apply();
    }
    get neutral() {
        return (0, $kms24.isValidColour)(localStorage.getItem("neutral")) || "slate";
    }
    set neutral(color) {
        localStorage.setItem("neutral", color);
        this.apply();
    }
    get scheme() {
        if ((0, $8PEJB.AppConfig).ENV == "crm-uat") return "dark";
        return $a5da0c8d6fec5f56$var$isValidColourScheme(localStorage.getItem("scheme")) || "auto";
    }
    set scheme(scheme) {
        localStorage.setItem("scheme", scheme);
        this.apply();
    }
    get width() {
        let width = localStorage.getItem("width");
        if (!$a5da0c8d6fec5f56$export$f0368d77463bcee8.includes(width)) return "default";
        else return width;
    }
    set width(width) {
        localStorage.setItem("width", width);
        this.apply();
    }
}
const $a5da0c8d6fec5f56$export$aba92a7f3273f617 = new $a5da0c8d6fec5f56$var$ThemeManager();

});
parcelRegister("kms24", function(module, exports) {

$parcel$export(module.exports, "mainColours", () => $abdfd6ae8b413399$export$6a50e9852546fda9);
$parcel$export(module.exports, "neutralColours", () => $abdfd6ae8b413399$export$101e482596492b95);
$parcel$export(module.exports, "isValidColour", () => $abdfd6ae8b413399$export$7d2a9ce18a5e0ed5);
const $abdfd6ae8b413399$export$6a50e9852546fda9 = [
    "red",
    "orange",
    "amber",
    "yellow",
    "lime",
    "green",
    "emerald",
    "teal",
    "cyan",
    "sky",
    "blue",
    "indigo",
    "violet",
    "purple",
    "fuchsia",
    "pink",
    "rose"
];
const $abdfd6ae8b413399$export$101e482596492b95 = [
    "slate",
    "gray",
    "zinc",
    "neutral",
    "stone"
];
const $abdfd6ae8b413399$export$dc65289aea5aed36 = [
    ...$abdfd6ae8b413399$export$6a50e9852546fda9,
    ...$abdfd6ae8b413399$export$101e482596492b95
];
function $abdfd6ae8b413399$export$7d2a9ce18a5e0ed5(colour) {
    return $abdfd6ae8b413399$export$dc65289aea5aed36.includes(colour) ? colour : false;
}

});


parcelRegister("6Wyqy", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("i5m4R"))($parcel$resolve("c2s7C")),
    $parcel$import("6Bggw"),
    $parcel$import("dZaQy"),
    $parcel$import("1zNYn"),
    $parcel$import("3PrTx"),
    $parcel$import("49zfv")
]).then(()=>parcelRequire('hkYFa'));

});
parcelRegister("i5m4R", function(module, exports) {
"use strict";

var $l4pap = parcelRequire("l4pap");
module.exports = $l4pap(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("l4pap", function(module, exports) {
"use strict";
var $f56d7e4bb9450c6a$var$cachedBundles = {};
var $f56d7e4bb9450c6a$var$cachedPreloads = {};
var $f56d7e4bb9450c6a$var$cachedPrefetches = {};
function $f56d7e4bb9450c6a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f56d7e4bb9450c6a$var$cachedPreloads;
        case 'prefetch':
            return $f56d7e4bb9450c6a$var$cachedPrefetches;
        default:
            return $f56d7e4bb9450c6a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f56d7e4bb9450c6a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("4Qxnf", function(module, exports) {
module.exports = $parcel$import("3PrTx").then(()=>parcelRequire('6RbKM'));

});

parcelRegister("lcpoX", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("i5m4R"))($parcel$resolve("c2s7C")),
    $parcel$import("6Bggw"),
    $parcel$import("dZaQy"),
    $parcel$import("1zNYn"),
    $parcel$import("3PrTx"),
    $parcel$import("49zfv"),
    $parcel$import("2IVZL")
]).then(()=>parcelRequire('knZsR'));

});

var $711d76e93f6be103$exports = {};
$parcel$extendImportMap({
    "49zfv": "app.f345671c.js",
    "biLir": "conversationActions.91c514b4.js",
    "3PrTx": "zohoAuth.5b2a9594.js",
    "lmQS0": "actions.f7919de0.js",
    "FBREW": "accountActions.1d4414ab.js",
    "YR4Pz": "opportunityActions.e2b11298.js",
    "6pJHJ": "logo.cdb6269f.svg",
    "gTlES": "jobs.dfb98e1a.js",
    "dZaQy": "app.5e557b5a.js",
    "6Bggw": "app.59cfd922.js",
    "jgUyV": "jobs.d6d14398.css",
    "bJqho": "listing.38d091a5.js",
    "5GXSY": "listing.2adbe429.css",
    "bFXxC": "details.d5e232a5.js",
    "iMxHb": "qualify.1abfd87e.js",
    "e7kTe": "qualify.f97dae65.css",
    "hIPsn": "quotation.ac70b0c0.js",
    "lqFPh": "issue.b17b66b6.js",
    "jFV8n": "approval.c9d8050c.js",
    "63z3X": "purchase.d7985baa.js",
    "batu9": "invoice.ca12c2f2.js",
    "d7pTR": "confirm.b2ba0597.js",
    "6mZSv": "licences.4d2d0b88.js",
    "gx8KT": "confirm.c1aa3395.css",
    "joOx0": "liquidfiles.60c27c3c.js",
    "9UxLK": "details.e1857fa8.js",
    "ddFja": "liquidTemplater.da63092a.js",
    "4hbgD": "dist.066e4086.js",
    "DgmYB": "collapseAttributeWhitespace.5db298ae.js",
    "gSEYr": "collapseBooleanAttributes.46e781d6.js",
    "2QLpU": "collapseWhitespace.801e85f1.js",
    "2dIaI": "custom.0be0c665.js",
    "Cx9Nu": "deduplicateAttributeValues.5c38d608.js",
    "rjtIS": "mergeScripts.f3afe628.js",
    "8dpXP": "mergeStyles.fbdbacb5.js",
    "6uLYe": "minifyConditionalComments.84fb7b05.js",
    "9p8Yb": "minifyCss.99c30ebd.js",
    "7hKDi": "minifyHtmlTemplate.35bf684d.js",
    "gYcRo": "minifyJs.a6bab967.js",
    "7SaLR": "removeRedundantAttributes.2a297cea.js",
    "brTV3": "minifyJson.b08760ee.js",
    "4GTq2": "minifyAttributes.4d3f9ffb.js",
    "ghZAd": "minifySvg.11773451.js",
    "3BNAz": "minifyUrls.93065175.js",
    "80yU5": "normalizeAttributeValues.a8ca61f0.js",
    "EpzpB": "removeAttributeQuotes.2ca3dbe2.js",
    "5IetB": "removeComments.f3c65dd0.js",
    "kvnZG": "removeEmptyAttributes.ca48d99d.js",
    "90Mra": "removeEmptyElements.bd32eb8b.js",
    "9d0yc": "removeOptionalTags.5793880d.js",
    "jxQtg": "removeUnusedCss.df717b91.js",
    "gH3Vy": "sortAttributes.73e36a29.js",
    "gGhWK": "sortAttributesWithLists.bf78d087.js",
    "j7vEC": "details.a80ff459.css",
    "lBhjh": "templates.451f3858.js",
    "bKngb": "details.6126389e.js",
    "4MLbs": "details.d1d7ace2.css",
    "4RgQD": "users.a1ac8af1.js",
    "k6g9m": "add.eff9daca.js",
    "8lgoA": "details.82f0f0dc.js",
    "4UmPe": "aad.d70cfda0.svg",
    "ko4Dc": "contacts.efe90141.js",
    "cyiUT": "details.31f1ba84.js",
    "7Fb98": "conversations.6a73d764.js",
    "auLk7": "conversations.68a45acd.css",
    "dRPtz": "details.e25a355c.js",
    "3Pdli": "details.eb1148ce.css",
    "lFF5G": "byZohoId.213e17c3.js",
    "eR2VB": "edit.b7742363.js",
    "4k4su": "edit.e9af3c8e.css",
    "aKQUk": "templates.ae36909d.js",
    "bef9U": "templates.9d78fff2.css",
    "479tx": "new.11f7fe39.js",
    "64uCz": "new.0df4cb4e.css",
    "dWu2v": "new.4f156aba.js",
    "04SXe": "detail.4dcf3e0f.js",
    "1CnAB": "detail.bab95b45.css",
    "4RmUo": "details.a686be19.js",
    "5qm3O": "details.a67b5b4e.css",
    "f0aSt": "addKey.ad071ce0.js",
    "iOWAM": "opportunities.b873817b.js",
    "fSsEb": "details.6031c1cd.js",
    "6amVk": "details.b863bad6.js",
    "jhavE": "details.776222fd.css",
    "1bfTk": "orders.556eb867.js",
    "kmt3R": "details.d8053509.js",
    "c5UnC": "details.4422ee57.css",
    "8dayi": "products.01a01610.js",
    "aCgVK": "details.d0885757.js",
    "4ncD0": "new-from-url.e7498b6c.js",
    "9UvOI": "workdocuments.c2e0605b.js",
    "cRvD7": "details.e3dd89c8.js",
    "lJKz6": "companies.74ecc0c2.js",
    "9FgmG": "companies.ae182c55.css",
    "3GNlc": "detail.1643d2a0.js",
    "dUCVN": "detail.58b666f5.css",
    "6Y03z": "P8PdfEmbed.2be45cd2.js",
    "cMVxM": "delete.772d3493.js",
    "biHzy": "merge.f37d0d56.js",
    "e6QNd": "merge.2e9c2800.css",
    "MT75M": "user-settings.ccd353bd.js",
    "1zNYn": "app.dff1c911.js",
    "eJupU": "user-settings.72050e63.css",
    "dNWgF": "change-log.b4f3deb8.js",
    "aPk9e": "markdownRenderer.b41a220c.js",
    "kYLxG": "change-log.04b0020b.css",
    "c2s7C": "app.36a2992a.css",
    "2IVZL": "fault-report.d421fa6d.js"
});


var $8PEJB = parcelRequire("8PEJB");

var $lsO5g = parcelRequire("lsO5g");

var $hWSXx = parcelRequire("hWSXx");

let $be0837de8b30bc39$var$preloadTaskState = [];
const $be0837de8b30bc39$var$html = String.raw;
function $be0837de8b30bc39$export$511662bf6797bcc4() {
    var container = document.getElementById('appContainer');
    container.innerHTML = $be0837de8b30bc39$var$html`
    <div class='preload ${$be0837de8b30bc39$var$preloadTaskState.map((t)=>t.task).join(" ")}'>
        <div class='preloadSidebar'></div>
        <div class="preloadTaskState">
            <h1>Welcome!</h1>
            <p>One second while we get the app ready for you...</p>
            <table class="taskState">
                <tbody>
                    ${$be0837de8b30bc39$var$preloadTaskState.map((task)=>`
                        <tr class='status-${task.state}'>
                            <td>${task.state == "current" ? "<i class='symbols spin'>refresh" : "<i class='symbols'>" + task.state}</i></td>
                            <td>
                                <h2>${(0, $977b3c7ce245d2b5$export$daab8a6139502cd1)[task.task].name}</h2>
                                <pre>${(task.result || "").toString()}</pre>
                            </td>
                        </tr>
                    `).join("")}
                    
                </tbody>
            </table>
            ${$be0837de8b30bc39$var$preloadTaskState.find((t)=>t.state == "current") ? '' : "<a href='/'>Restart the application</a>"}
        </div>
    </div>
    `;
}
let $be0837de8b30bc39$var$runners = 0;
async function $be0837de8b30bc39$var$runTask(task) {
    $be0837de8b30bc39$var$runners++;
    task.state = "current";
    $be0837de8b30bc39$export$511662bf6797bcc4();
    let def = (0, $977b3c7ce245d2b5$export$daab8a6139502cd1)[task.task];
    let fn = def.function;
    console.time(task.task);
    let cont = await fn().then((result)=>{
        task.result = result;
        task.state = "done";
        $be0837de8b30bc39$export$511662bf6797bcc4();
        return true;
    }).catch((err)=>{
        console.error(err);
        task.result = err;
        task.state = "error";
        $be0837de8b30bc39$export$511662bf6797bcc4();
        return def.nonFatal === true;
    });
    console.timeEnd(task.task);
    $be0837de8b30bc39$var$runners--;
    if (cont) $be0837de8b30bc39$var$stepTasks();
}
function $be0837de8b30bc39$var$stepTasks() {
    if ($be0837de8b30bc39$var$runners !== 0) return;
    let next = $be0837de8b30bc39$var$preloadTaskState.find((t)=>t.state == "pending");
    if (next) $be0837de8b30bc39$var$runTask(next);
}
function $be0837de8b30bc39$export$9ca1a25b80814932(task, when) {
    if (when == "queue") $be0837de8b30bc39$var$preloadTaskState.concat(task.map((t)=>({
            task: t,
            state: "pending",
            result: null
        })));
    else if (when == "replace") $be0837de8b30bc39$var$preloadTaskState = [
        ...$be0837de8b30bc39$var$preloadTaskState.filter((t)=>t.state !== "pending"),
        ...task.map((t)=>({
                task: t,
                state: "pending",
                result: null
            }))
    ];
    else if (when == "next") $be0837de8b30bc39$var$preloadTaskState = [
        ...$be0837de8b30bc39$var$preloadTaskState.filter((t)=>t.state !== "pending"),
        ...task.map((t)=>({
                task: t,
                state: "pending",
                result: null
            })),
        ...$be0837de8b30bc39$var$preloadTaskState.filter((t)=>t.state == "pending")
    ];
    $be0837de8b30bc39$var$stepTasks();
}





const $977b3c7ce245d2b5$export$daab8a6139502cd1 = {
    callback: {
        name: "Log you in",
        function: (0, $hWSXx.tryAuthenticate)
    },
    acceptInvite: {
        name: "Register your account",
        function: (0, $hWSXx.acceptInvite)
    },
    ensureUserAuth: {
        name: "Check account details",
        function: async ()=>{
            if (!await (0, $hWSXx.userIsAuthed)()) (0, $be0837de8b30bc39$export$9ca1a25b80814932)([
                "login"
            ], "next");
        }
    },
    login: {
        name: "Redirect to login page",
        function: ()=>{
            (0, $be0837de8b30bc39$export$9ca1a25b80814932)([], "replace");
            return (0, $hWSXx.userLogin)();
        }
    },
    clearAuthStorage: {
        name: "Log out of this browser",
        function: async ()=>{
            localStorage.clear();
            sessionStorage.clear();
        }
    },
    clearIndexedDB: {
        name: "Remove cached data",
        function: async ()=>{
            let dbs = await indexedDB.databases();
            await Promise.all(dbs.map((db)=>indexedDB.deleteDatabase(db.name)));
        }
    },
    logout: {
        name: "Log out other browsers",
        nonFatal: true,
        function: (0, $hWSXx.logout)
    },
    // loadSharedWorker: {
    //     name: "Load shared worker",
    //     function: bringUpSharedWorker       
    // },
    loadConfig: {
        name: "Load app config",
        function: async ()=>(0, $8PEJB.LoadConfig)().then(()=>(0, $lsO5g.themeManager).apply())
    },
    initApp: {
        name: "Load app",
        function: async ()=>(parcelRequire("6Wyqy")).then((m)=>m.InitApp())
    },
    reload: {
        name: "Restart app",
        function: async ()=>location.replace("/")
    },
    zohoCallback: {
        name: "Finish Zoho login",
        function: async ()=>(parcelRequire("4Qxnf")).then((m)=>m.handleZohoCallback())
    },
    zohoLogout: {
        name: "Log out of Zoho",
        function: async ()=>localStorage.removeItem("zohoToken")
    },
    zohoRedirect: {
        name: "Redirect to Zoho login",
        function: async ()=>(parcelRequire("4Qxnf")).then((m)=>location.replace(m.getZohoRedirectUrl()))
    },
    close: {
        name: "Close window",
        function: async ()=>window.close()
    }
};
let $977b3c7ce245d2b5$var$openerIsSameOrigin = false;
try {
    $977b3c7ce245d2b5$var$openerIsSameOrigin = window.opener.location.origin === window.location.origin;
} catch (e) {}
const $977b3c7ce245d2b5$export$e4444ecb26a88bb7 = [
    "ensureUserAuth",
    "loadConfig",
    "initApp"
];
const $977b3c7ce245d2b5$var$ClearTaskList = [
    "clearAuthStorage",
    "clearIndexedDB"
];
const $977b3c7ce245d2b5$export$bb21666871955e28 = {
    "default": $977b3c7ce245d2b5$export$e4444ecb26a88bb7,
    "invite": [
        "acceptInvite",
        "login"
    ],
    "callback": [
        "callback",
        ...$977b3c7ce245d2b5$var$openerIsSameOrigin ? [
            "close"
        ] : $977b3c7ce245d2b5$export$e4444ecb26a88bb7
    ],
    "clear_local": $977b3c7ce245d2b5$var$ClearTaskList,
    "logout": [
        "logout",
        ...$977b3c7ce245d2b5$var$ClearTaskList
    ],
    "zoho_callback": [
        "zohoCallback",
        'close'
    ],
    "zoho_redir": [
        "zohoLogout",
        "loadConfig",
        "zohoRedirect"
    ]
};




var $lsO5g = parcelRequire("lsO5g");

window.addEventListener('keydown', async (e)=>{
    if (e.key !== 'F9') return;
    if (!confirm("Would you like to take a snapshot?")) return;
    let { default: submitFaultReport } = await (parcelRequire("lcpoX"));
    submitFaultReport();
});
let $ad3b1e845cc3eaee$var$taskList = (0, $977b3c7ce245d2b5$export$e4444ecb26a88bb7);
async function $ad3b1e845cc3eaee$var$checkStorageQuota() {
    let details = await navigator.storage.estimate();
    let quota = details.quota;
    if (!quota) return;
    let idbQuota = details.usageDetails?.indexedDB ?? 0;
    if ((details.usage ?? 0) > quota * 0.75 || idbQuota > quota * 0.5 || idbQuota > 512000000) $ad3b1e845cc3eaee$var$taskList.unshift("clearIndexedDB");
}
async function $ad3b1e845cc3eaee$var$doInitTasks() {
    if (location.pathname.startsWith("/auth/")) {
        let tlName = location.pathname.split("/")[2];
        var selectedTaskList = (0, $977b3c7ce245d2b5$export$bb21666871955e28)[tlName];
        if (selectedTaskList) $ad3b1e845cc3eaee$var$taskList = selectedTaskList;
        else alert("Warning: No such task list '" + tlName + "', using default");
    }
    await $ad3b1e845cc3eaee$var$checkStorageQuota().catch(console.error);
    (0, $be0837de8b30bc39$export$9ca1a25b80814932)($ad3b1e845cc3eaee$var$taskList, "replace");
}
let $ad3b1e845cc3eaee$var$appContainer = document.createElement("div");
$ad3b1e845cc3eaee$var$appContainer.id = "appContainer";
document.body.appendChild($ad3b1e845cc3eaee$var$appContainer);
$ad3b1e845cc3eaee$var$doInitTasks();
(0, $lsO5g.themeManager).apply();


//# sourceMappingURL=html.816d57c2.js.map
